import { Link, useLocation } from 'react-router-dom';
import { flushScrollToTop } from '../utils/scrollLock';
import { isSameRoute } from './SmartLink';

const SIZE_CLASS = {
  header: 'lumora-brand--header',
  md: 'lumora-brand--md',
  lg: 'lumora-brand--lg',
  hero: 'lumora-brand--hero',
};

const Logo = ({ className = '', size = 'md', link = true }) => {
  const location = useLocation();

  const handleHomeClick = (event) => {
    if (isSameRoute(location.pathname, '/')) {
      event.preventDefault();
    }
    flushScrollToTop();
  };

  const panel = (
    <div className="lumora-brand__panel transition-transform duration-300 group-hover:scale-[1.02]">
      <span className="lumora-brand__title" aria-hidden>
        LUMORA
      </span>
      <span className="lumora-brand__tagline" aria-hidden>
        CURATED LIVING SPACES
      </span>
      <div className="lumora-brand__divider" aria-hidden>
        <span className="lumora-brand__divider-line" />
        <span className="lumora-brand__divider-gem" />
        <span className="lumora-brand__divider-line" />
      </div>
    </div>
  );

  if (!link) {
    return (
      <div
        className={`lumora-brand group inline-flex shrink-0 ${SIZE_CLASS[size] || SIZE_CLASS.md} ${className}`}
        aria-label="LUMORA — Curated Living Spaces"
      >
        {panel}
      </div>
    );
  }

  return (
    <Link
      to="/"
      onClick={handleHomeClick}
      className={`lumora-brand group inline-flex shrink-0 ${SIZE_CLASS[size] || SIZE_CLASS.md} ${className}`}
      aria-label="LUMORA — Curated Living Spaces"
    >
      {panel}
    </Link>
  );
};

export default Logo;
